export default __webpack_public_path__ + "static/4-2a08b353b1f332ba6f022fd535c4a716.jpeg";